import { InsuranceOpsGetPolicyResponse as InsuranceOpsGetEndorsementsResponse } from "../../../types/responses";

type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

type PartialInsuranceOpsGetEndorsementsResponse = Optional<
  InsuranceOpsGetEndorsementsResponse,
  "EffectiveDate" | "ExpirationDate"
>;

export function createEndorsementsMap<T extends string>(
  obj: Record<T, PartialInsuranceOpsGetEndorsementsResponse>
) {
  const objWithId = Object.entries<PartialInsuranceOpsGetEndorsementsResponse>(
    obj
  ).map(([key, value]) => [
    key,
    {
      EffectiveDate: "1999-01-01",
      ExpirationDate: "2999-12-31",
      ...value,
    },
  ]);

  return Object.fromEntries(objWithId) as Record<
    T,
    InsuranceOpsGetEndorsementsResponse
  >;
}
